import React, { useState, useEffect } from "react";
import { Typography, Grid, Container, Box } from "@mui/material";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import LoaderContainer from "../../components/LoaderContainer";
import CustomButton from "../../components/Custom/CustomButton";
import { useNavigate } from "react-router-dom";
import { CustomLabel } from "../../components/Custom/CustomTypography";
import { CustomValue } from "../../components/Custom/CustomTypography";
import { useLocation } from "react-router-dom";
import ConfirmationPopup from "../../components/Popup/GenericPopup";
export default function BidDetailedView() {
  const [requirementData, setRequirementData] = useState([]);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const reqId = queryParams.get("req_id");

  const details = requirementData.commodity
    ? [
        { label: "Quantity(MT)", value: `${requirementData.quantity}MT` },
        { label: "Date Needed on", value: requirementData.date_needed },
        { label: "Location", value: requirementData.district.name },
        { label: "Max Price (Rs/MT)", value: requirementData.max_price },
        {
          label: "Quality Requirements",
          value: requirementData.quality_requirement,
        },
        { label: "Who Can Respond? ", value: requirementData.responder_type },
      ]
    : [];

  useEffect(() => {
    fetchRequirementData(reqId);
  }, []);

  const fetchRequirementData = async (reqId) => {
    api
      .get(`/buyer/requirements/${reqId}/`)
      .then((result) => {
        setRequirementData(result.data);
        setLoading(false);
      })
      .catch((err) => {
        alert("Error: " + err.response.data.non_field_errors[0]);
        setLoading(false);
      });
  };

  const handleFulfilled = async () => {
    try {
      const response = await api.patch(`/buyer/requirements/${reqId}/`, {
        fulfilled: true,
      });
      console.log("Requirement marked as fulfilled successfully", response.data);
      setTimeout(() => {
        navigate("/"); // Replace with your target path
      }, 2000);
    } catch (error) {
      console.error("Error updating requirement:", error);
    }
  };

  const handleEdit = () => {
    navigate(`/buyer/add-requirement?requirementId=${reqId}`);
  };

  const handleDelete = () => {
    setDeleteConfirmationOpen(true);
  };
  const handleConfirmDelete = async () => {
    setLoading(true);
    try {
      const response = await api.delete(`/buyer/requirements/${reqId}/`);
      console.log("Requirement deleted successfully", response.data);
      setTimeout(() => {
        navigate("/");
      }, 100);
      setLoading(false);
    } catch (error) {
      console.error("Error deleting requirement:", error);
      setLoading(false);
    }
  };

  return (
    <>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <Container
          maxWidth="xs"
          style={{
            height: "94vh",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              mb: 2,
              fontSize: "30px",
              fontWeight: 700,
              marginTop: "10px",
            }}
          >
            {requirementData.commodity
              ? `${requirementData.commodity.name}`
              : ""}
          </Typography>
          <div
            style={{
              height: "100%",
              maxHeight: "100%",
              overflowY: "auto",
            }}
          >
            <CustomLabel>
              {requirementData.commodity
                ? `${requirementData.quantity}MT, ${requirementData.district.name}, ${requirementData.date_needed}`
                : ""}
            </CustomLabel>
            <Box sx={{ marginTop: "10px" }}>
              {details.map(({ label, value }, index) => (
                <React.Fragment key={index}>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <CustomLabel>
                        <Typography variant="body1" fontWeight="bold">
                          {label}:
                        </Typography>
                      </CustomLabel>
                    </Grid>
                    <Grid item xs={6}>
                      <CustomValue>
                        <Typography variant="body1">{value}</Typography>
                      </CustomValue>
                    </Grid>
                  </Grid>
                </React.Fragment>
              ))}
            </Box>
          </div>
          <div>
            <CustomButton hideIcon onClick={handleEdit}>
              {t("Edit")}
            </CustomButton>
            <CustomButton
              hideIcon
              onClick={() => {
                handleFulfilled();
              }}
            >
              {t("Mark as Fulfilled")}
            </CustomButton>
            <CustomButton
              hideIcon
              backgroundColor="#CF5C5C"
              onClick={handleDelete}
            >
              {t("Delete")}
            </CustomButton>
          </div>
        </Container>
      </LoaderContainer>
      <ConfirmationPopup
        open={deleteConfirmationOpen}
        handleClose={() => setDeleteConfirmationOpen(false)}
        handleConfirm={handleConfirmDelete}
        title="Confirm Delete"
        message="Are you sure you want to delete this requirement?"
        confirmButtonText="Delete"
        cancelButtonText="Cancel"
      />
    </>
  );
}
